




































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenantCatalog/common';
import Moment from 'moment';

@Component
export default class BillingItemView extends Vue {
  public items: Common. BillingItem[] = new Array(0);
  public params: Common.BillingItemQuery = new Common.BillingItemQuery();
  public exportQuery = new Common.ExportQuery('請求明細', this.params);
  public importQuery = new Common.ImportQuery('請求明細', 'BillingItem');  
  public sortOptions: any = [{ value: 'tenantId', text: 'テナントID' },{ value: 'tenantName', text: 'テナント名称' }];
  @Prop() public tenantId:string;
  @Prop() public closingDate:Date;

  public created(){
    if (this.tenantId) this.params.tenantId = this.tenantId;
    if (this.closingDate) this.params.closingDate = this.closingDate;
    
  }
  public showBillingItems(tenantId:string, closingDate:Date){
      this.$router.push(String.format('/project/billing?tenantId={0}&closingDate={1}',tenantId,Moment(closingDate).format("YYYY-MM-DD")));
  }  
}
